import { Component } from '@theme/component';

/**
 * A size chart with a "Produktmaße" / "Körpermaße" tab switch.
 *
 * @typedef {object} SizeChartRefs
 * @property {HTMLButtonElement[]} tab - The tab buttons
 * @property {HTMLElement} panelMass - The product measurements table wrapper
 * @property {HTMLElement} panelBody - The body measurements table wrapper
 *
 * @extends {Component<SizeChartRefs>}
 */
export class SizeChartComponent extends Component {
  requiredRefs = ['tab', 'panelMass', 'panelBody'];

  /**
   * Shows the requested measurement table and updates the pressed tab.
   *
   * @param {{ view: string }} data
   */
  switchView({ view }) {
    const { tab, panelMass, panelBody } = this.refs;

    panelMass.hidden = view !== 'mass';
    panelBody.hidden = view !== 'body';

    for (const button of tab) {
      button.setAttribute('aria-pressed', String(button.dataset.view === view));
    }
  }
}

if (!customElements.get('size-chart-component')) {
  customElements.define('size-chart-component', SizeChartComponent);
}
